import type { PageInitInput, PageInitOutput, PageStreamInput } from '@/domains/seek/types';
import type { PsHttpSSE } from '@patsnap-utils/sse';
import type { PatSnapCommonResponseData } from '@patsnap/tahiti-core';
import type { RequestConfig } from '@patsnap/common-ps-http';

export const PageRepository = Symbol('PageRepository');

export interface PageRepository {
    pageInit(initData: PageInitInput): Promise<PageInitOutput>;
    getPageStream<T>(streamInput: PageStreamInput): PsHttpSSE<T>
    stopPageStreamEvent(question_id: string):Promise<unknown>;
    request<T extends PatSnapCommonResponseData>(config: RequestConfig): Promise<T>;
}
